export default __webpack_public_path__ + "static/sellAndSupportBg-eab5dfb2ed1a58d478e7950b34b1dc57.png";